import { createSlice } from "@reduxjs/toolkit";
import SurveysService from "../services/SurveysService";

const surveysSlice = createSlice({
    name: 'surveys',
    initialState: { surveysList: [], surveysCompletedCountMap: {} },
    reducers: {
        initSurveysList: (state, action) => {
            return {
                ...state,
                surveysList: action.payload
            }
        },
        clearSurveysList: (state, action) => {
            return {
                ...state,
                surveysList: []
            }
        },
        initSurveysCompletedCountMap: (state, action) => {
            return {
                ...state,
                surveysCompletedCountMap: action.payload
            }
        },
        clearSurveysCompletedCountMap: (state, action) => {
            return {
                ...state,
                surveysCompletedCountMap: {},
            }
        },
        changeSurveyStatus: (state, action) => {
            const quest = state.surveysList.find(quest => quest.questId === action.payload.id);
            quest.questStatus = action.payload.status;
        },
        removeSurveyFromListById : (state, action) => {
            const updatedSurveys = state.surveysList.filter(survey => survey.questId !== action.payload.questId);
            return {
                ...state,
                surveysList: updatedSurveys
            }
        }
    }
});

export const fetchSurveysList = (userId, okCallback, koCallback) => (dispatch) => {
    SurveysService.getSurveysList(userId,
        (response) => {
            dispatch(initSurveysList(response.data));
            okCallback && okCallback();
        },
        (error) => {
            console.log("Error! Cannot retrieve surveys list!");
            koCallback && koCallback();
        }
    );
};

export const fetchSurveysCompletedCounts = (userId, okCallback, koCallback) => (dispatch) => {
    SurveysService.getRespondentsCountByTypeForAllSurveysOfUser(
        "completed", userId,
        (response) => {
            dispatch(initSurveysCompletedCountMap(response.data));
            okCallback && okCallback();
        },
        (error) => {
            console.log("Error! Cannot retrieve surveys completed respondents counts!");
            koCallback && koCallback();
        }
    )
};

export const { initSurveysList, clearSurveysList, initSurveysCompletedCountMap, clearSurveysCompletedCountMap, changeSurveyStatus, removeSurveyFromListById } = surveysSlice.actions;
export default surveysSlice.reducer;